export default __webpack_public_path__ + "static/_00-Home-Hero video-f315dddfad7eaeacc571f36c9e928e84.mp4";